import styled from 'styled-components';
import { TOOLBAR_ROW_HEIGHT } from '@/components/FilterPanel/FilterPanel.styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-small);
  min-height: ${TOOLBAR_ROW_HEIGHT};
  padding: var(--spacing-small) 0;
  border-bottom: 1px solid var(--grey-200);
  margin-bottom: var(--spacing-base);
  box-sizing: border-box;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
  font-size: 13px;
  color: var(--grey-500);
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-base);
  background: var(--white);
  cursor: pointer;
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--black);

  @media (width >= 48rem) {
    display: none;
  }
`;

export const SortWrapper = styled.div`
  & select {
    padding: 8px 12px;
    border: 1px solid var(--grey-300);
    border-radius: var(--radius-base);
    font-size: var(--font-size-text-sm);
    background: var(--white);
  }
`;
